<table *ngIf="hseReport.length || dprHse.comment" class="layout-fixed striped">
  <colgroup>
    <col class="width-30" />
    <col class="width-10" />
    <col class="width-10" />
    <col class="width-10" />
    <col class="width-40" />
  </colgroup>
  <thead>
    <tr>
      <th colspan="5">
        <h3>{{customNames.hseTabName}}</h3>
      </th>
    </tr>
  </thead>
  <ng-container *ngIf="hseReport.length">
    <tbody class="secondary-header">
      <tr>
        <td i18n="@@report.reportHse.colCategory">Category</td>
        <td class="text-center">{{StaticMessage.PreviousColumn | staticMessage}}</td>
        <td class="text-center">{{StaticMessage.TodayColumn | staticMessage}}</td>
        <td class="text-center">{{StaticMessage.TotalColumn | staticMessage}}</td>
        <td>{{StaticMessage.CommentColumn | staticMessage}}</td>
      </tr>
    </tbody>
  </ng-container>
  <tbody>
    <tr *ngFor="let hse of hseReport">
      <td class="accent">{{hse.name}}</td>
      <td class="text-center">{{hse.previous}}</td>
      <td class="text-center">{{hse.today}}</td>
      <td class="text-center">{{hse.total}}</td>
      <td>{{hse.comment}}</td>
    </tr>
  </tbody>
  <tbody class="secondary-header" *ngIf="dprHse.comment">
    <tr>
      <td colspan="5">{{StaticMessage.CommentPluralLabel | staticMessage}}</td>
    </tr>
  </tbody>
  <tbody *ngIf="dprHse.comment">
    <tr>
      <td colspan="5" class="white-space-pre-wrap" [innerHTML]="(dprHse.comment | trim) || '-'"></td>
    </tr>
  </tbody>
</table>
